import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  FormConfigContainer,
  FormConfigWrapper,
  FormConfigSectionWrapper,
  FormConfigHr,
  SelectStyles,
} from "./FormConfiguration.styled";
import { Form } from "react-bootstrap";
import { useLazyQuery } from "@apollo/client";
import Select1 from "react-select";
import {
  COUNTRIES_BY_CLIENT,
  ALL_LOBS_COUNTRY,
} from "../../../GraphQL/Queries.js";
import { getStateLoginComplete } from "../../../containers/LayoutHome/stateLogin.js";
import { setStateSurveyConfiguration } from "../../../helpers/StateFormConfiguration";
import { theme as themeConfig } from "../../../themes/themes";
import PointersLine from "../../Loaders/PointersLine/PointersLine";
import PropTypes from "prop-types";

const FormConfiguration = ({
  formName,
  setFormName,
  formDescription,
  setFormDescription,
  countrySelected,
  setCountrySelected,
  setStateSelected,
  citySelected,
  setCitySelected,
  lobSelected,
  setLobSelected,
  action,
}) => {
  const user = useMemo(() => getStateLoginComplete(), []);
  const [countries, setCountries] = useState([]);
  const [lobs, setLobs] = useState([]);
  const [cities, setCities] = useState([]);
  const clientId = useMemo(() => user.clientId, []);
  const rSelectedCountries = useRef();
  const rSelectedCity = useRef();
  const rSelectedLob = useRef();

  const [runQueryCountry, { loading: loadingQueryCountry }] = useLazyQuery(
    COUNTRIES_BY_CLIENT,
    {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllCountries = data.countryLocationList.map((element) => {
          return {
            ...element,
            value: element?.countryId,
            label: element?.countryName,
          };
        });
        setCountries(resultOfAllCountries);
      },
    }
  );

  const [runQueryLobsByCountry, { loading: loadingQueryLobsByCountry }] =
    useLazyQuery(ALL_LOBS_COUNTRY, {
      fetchPolicy: "network-only",
      onCompleted: (data) => {
        let resultOfAllLobs = data.lobsListByCountry.map((element) => {
          return {
            value: element?.lobId,
            label: element?.lobName,
          };
        });
        setLobs(resultOfAllLobs);
      },
    });

  const getCities = (id) => {
    let selectedCountry = countries.filter((e) => e.countryId === parseInt(id));
    if (selectedCountry?.length > 0) {
      let citiesArr = selectedCountry[0].cities.map((e) => {
        return {
          ...e,
          value: e.cityId,
          label: e.cityName,
        };
      });
      setCities(citiesArr);
    } else {
      setCities([]);
    }
  };

  const handleChangeSelectCountries = (item) => {
    let countryId = item.value;
    getCities(item.value);
    runQueryLobsByCountry({
      variables: { countryId: parseInt(countryId), searchBy: "" },
      context: { clientName: "LinkUsers" },
    });
    setCountrySelected(countryId);
    setStateSelected();
    setCitySelected();
    rSelectedCity.current.clearValue();
  };

  const handleChangeCity = (item) => {
    if (item) {
      setCitySelected(item.value);
    }
  };

  const handleChangeLOBS = (item) => {
    if (item.length > 0) {
      setLobSelected(item);
    } else {
      setLobSelected([]);
    }
  };

  useEffect(() => {
    if (formName) {
      setStateSurveyConfiguration(formName, "surveyName");
    }
    if (formDescription) {
      setStateSurveyConfiguration(formDescription, "surveyDescription");
    }
  }, [formName, formDescription]);

  useEffect(() => {
    if (clientId) {
      runQueryCountry({
        variables: { clientId: clientId },
        context: { clientName: "LinkUsers" },
      });
    }
  }, []);

  useEffect(() => {
    if (action === "edit" && countrySelected) {
      getCities(countrySelected);
    }
  }, [countries, action]);

  return (
    <FormConfigContainer>
      <FormConfigWrapper>
        <FormConfigSectionWrapper>
          <Form.Label>Form Name</Form.Label>
          <Form.Control
            placeholder="Add name"
            value={formName}
            type="text"
            onChange={(e) => setFormName(e.target.value)}
          />
        </FormConfigSectionWrapper>
        <FormConfigSectionWrapper>
          <Form.Label>Description</Form.Label>
          <Form.Control
            placeholder="Add description"
            value={formDescription}
            type="text"
            onChange={(e) => setFormDescription(e.target.value)}
          />
        </FormConfigSectionWrapper>
        <FormConfigHr />
        {!loadingQueryCountry && (
          <FormConfigSectionWrapper>
            <Form.Label>Country</Form.Label>
            <Select1
              placeholder="Select a country"
              ref={rSelectedCountries}
              options={countries}
              styles={SelectStyles}
              onChange={handleChangeSelectCountries}
              value={countries.filter((f) => f.value === countrySelected)[0]}
            />
          </FormConfigSectionWrapper>
        )}
        {
          <FormConfigSectionWrapper>
            <Form.Label>City</Form.Label>
            <Select1
              placeholder="Select a city"
              ref={rSelectedCity}
              options={cities}
              styles={SelectStyles}
              onChange={handleChangeCity}
              value={cities.filter((f) => f.value === citySelected)[0]}
            />
          </FormConfigSectionWrapper>
        }
        {!loadingQueryLobsByCountry && (
          <FormConfigSectionWrapper>
            <Form.Label>LOB</Form.Label>
            <Select1
              isMulti
              placeholder="Select LOBs"
              ref={rSelectedLob}
              options={lobs}
              styles={SelectStyles}
              onChange={handleChangeLOBS}
              value={lobSelected}
            />
          </FormConfigSectionWrapper>
        )}
        {(loadingQueryCountry || loadingQueryLobsByCountry) && (
          <PointersLine color={themeConfig.text.primary} />
        )}
      </FormConfigWrapper>
    </FormConfigContainer>
  );
};

export default FormConfiguration;

FormConfiguration.propTypes = {
  formName: PropTypes.string,
  setFormName: PropTypes.func,
  formDescription: PropTypes.string,
  setFormDescription: PropTypes.func,
  countrySelected: PropTypes.number,
  setCountrySelected: PropTypes.func,
  setStateSelected: PropTypes.func,
  citySelected: PropTypes.number,
  setCitySelected: PropTypes.func,
  lobSelected: PropTypes.array,
  setLobSelected: PropTypes.func,
  action: PropTypes.string,
};
